import { useEffect } from 'react'

import { useRouter } from 'next/router'

import Auth from 'layouts/Auth.js'
import { useAuth } from 'context/authContext'

export default function Register() {
	const { isAuthenticated, getRedirect, clearRedirect, loading, register } = useAuth()
	const router = useRouter()

	useEffect(() => {
		if (!loading) {
			if (isAuthenticated) {
				const redirect = getRedirect()
				if (redirect) {
					router.push(redirect) // go to page which redirected to login
					clearRedirect()
				} else {
					router.push('/admin/dashboard') // go to dashboard
				}
			}
		}
	}, [router, getRedirect, clearRedirect, loading, isAuthenticated])

	return (
		<>
			<div className='container mx-auto px-4 h-full'>
				<div className='flex content-center items-center justify-center h-full'>
					<div className='w-full lg:w-6/12 px-4'>
						<div className='relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-slate-200 border-0'>
							<div className='rounded-t mb-0 px-6 py-6'>
								<div className='text-center mb-3'>
									<h6 className='text-slate-500 text-sm font-bold'>Sign up</h6>
								</div>
								<hr className='mt-6 border-b-1 border-slate-300' />
							</div>
							<div className='flex-auto px-4 lg:px-10 py-10 pt-0'>
								<div className='text-slate-400 text-center mb-3 font-bold'>
									<small>please fill the form with your info</small>
								</div>
								<form onSubmit={register}>
									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											First Name
										</label>
										<input
											type='text'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='First Name'
											name='firstname'
											required={true}
										/>
									</div>
									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Last Name
										</label>
										<input
											type='text'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Last Name'
											name='lastname'
											required={true}
										/>
									</div>

									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Username
										</label>
										<input
											type='text'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='username'
											name='username'
											required={true}
										/>
									</div>

									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Email
										</label>
										<input
											type='email'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Email'
											name='email'
											required={true}
										/>
									</div>

									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Password
										</label>
										<input
											type='password'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Password'
											name='password'
											required={true}
										/>
									</div>

									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Comfirm Password
										</label>
										<input
											type='password'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Password'
											name='password2'
										/>
									</div>

									{/* <div>
										<label className='inline-flex items-center cursor-pointer'>
											<input
												id='customCheckLogin'
												type='checkbox'
												className='form-checkbox border-0 rounded text-slate-700 ml-1 w-5 h-5 ease-linear transition-all duration-150'
											/>
											<span className='ml-2 text-sm font-semibold text-slate-600'>
												I agree with the{" "}
												<a
													href='#pablo'
													className='text-sky-500'
													onClick={(e) => e.preventDefault()}
												>
													Privacy Policy
												</a>
											</span>
										</label>
									</div> */}

									<div className='text-center mt-6'>
										<button
											className='bg-slate-800 text-white active:bg-slate-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150'
											type='submit'
										>
											Create Account
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

Register.layout = Auth
